module.exports = __webpack_public_path__ + "img/house-grey.51838043.svg";